import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthQuery } from '@app/auth/auth.query';

/**
 * Allows only superusers (t_beuser.su == 1, surfaced via the auth state) onto a
 * route. Non-superusers are redirected to the dashboard home. The API enforces
 * the same check server-side on /v3/config/* — this guard is the client-side UX.
 */
@Injectable({
  providedIn: 'root',
})
export class SuperuserGuard implements CanActivate {
  constructor(private authQuery: AuthQuery, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this.authQuery.isSuperuser) {
      return true;
    }
    return this.router.createUrlTree(['/home']);
  }
}
